import { ActionButtonStyle, CustomPaletteColor } from '../../theme/app.theme';
import { SxProps, Theme } from '@mui/material/styles';

import AddIcon from '@mui/icons-material/Add';
import Announcement from '@mui/icons-material/Announcement';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ClearIcon from '@mui/icons-material/Clear';
import { ConvergeButton } from './button';
import DeleteIcon from '@mui/icons-material/Delete';
import DescriptionIcon from '@mui/icons-material/Description';
import DoneIcon from '@mui/icons-material/Done';
import EditIcon from '@mui/icons-material/Edit';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { NewConvergeButton } from './new-button';
import { PropsOf } from '@emotion/react';

export enum ActionButtonType {
  Add,
  Edit,
  Delete,
  Success,
  View,
  Info,
  Clear,
  Assign,
  Unassign,
}

const ACTION_BUTTON_OPTIONS: Record<
  ActionButtonType,
  Omit<PropsOf<typeof ConvergeButton>, 'label'>
> = {
  [ActionButtonType.Add]: {
    color: CustomPaletteColor.Blue,
    startIcon: <AddIcon />,
  },
  [ActionButtonType.Edit]: {
    color: CustomPaletteColor.Warning,
    startIcon: <EditIcon />,
  },
  [ActionButtonType.Delete]: {
    color: CustomPaletteColor.Error,
    startIcon: <DeleteIcon />,
  },
  [ActionButtonType.Success]: {
    color: CustomPaletteColor.Success,
    startIcon: <DoneIcon />,
  },
  [ActionButtonType.View]: {
    color: CustomPaletteColor.DarkGray,
    startIcon: <DescriptionIcon />,
  },
  [ActionButtonType.Info]: {
    color: CustomPaletteColor.Secondary,
    startIcon: <Announcement />,
  },
  [ActionButtonType.Clear]: {
    color: CustomPaletteColor.Error,
    startIcon: <ClearIcon />,
  },
  [ActionButtonType.Assign]: {
    color: CustomPaletteColor.Success,
    startIcon: <CheckCircleOutlinedIcon />,
  },
  [ActionButtonType.Unassign]: {
    color: CustomPaletteColor.Error,
    startIcon: <HighlightOffIcon />,
  },
};

interface ITableActionButtonProps {
  type?: ActionButtonType;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
  visible?: boolean;
  sx?: SxProps<Theme>;
}

export const TableActionButton = ({
  type,
  label,
  onClick,
  disabled = false,
  loading = false,
  visible = true,
  sx = ActionButtonStyle,
}: ITableActionButtonProps) => {
  if (!visible) {
    return null;
  }

  const loadingButtonProps = type ? ACTION_BUTTON_OPTIONS[type] : {};

  return (
    <NewConvergeButton
      variant="contained"
      size="small"
      sx={sx}
      // disableElevation
      onClick={onClick}
      // loadingPosition={'start'}
      disabled={disabled}
      loading={loading}
      label={label}
      {...loadingButtonProps}
    />
  );
};
